/* BrainChip Direct — Shopify Theme JavaScript */

/* ====================================================
   Sticky Header
   ==================================================== */
(function() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ====================================================
   Sticky header + announcement bar stacking
   Header and announcement bar sit in separate sticky wrappers
   (see .shopify-section-group-header-group in brainchip.css).
   Measure the header's live height so the announcement bar
   sticks directly beneath it instead of overlapping.
   ==================================================== */
(function() {
  const headerWrap = document.querySelector('.shopify-section-group-header-group:first-of-type');
  if (!headerWrap) return;
  function setHeaderHeightVar() {
    document.documentElement.style.setProperty('--sticky-header-height', headerWrap.getBoundingClientRect().height + 'px');
  }
  setHeaderHeightVar();
  window.addEventListener('resize', setHeaderHeightVar);
  if (window.ResizeObserver) {
    new ResizeObserver(setHeaderHeightVar).observe(headerWrap);
  }
})();

/* ====================================================
   Mobile Drawer Menu
   ==================================================== */
(function() {
  const menuOpen = document.getElementById('mobile-menu-open');
  const menuClose = document.getElementById('mobile-menu-close');
  const drawer = document.getElementById('mobile-drawer');
  const backdrop = document.getElementById('mobile-drawer-backdrop');

  if (!drawer) return;

  function openMenu() {
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (menuOpen) menuOpen.addEventListener('click', openMenu);
  if (menuClose) menuClose.addEventListener('click', closeMenu);
  if (backdrop) backdrop.addEventListener('click', closeMenu);
})();

/* ====================================================
   Hero Product Showcase Slideshow
   Runs on both desktop and mobile. Mobile early-return
   removed — carousel is now reinstated on mobile between
   subtext and CTA row via display:contents ordering in CSS.
   Touch swipe added for mobile navigation.
   ==================================================== */
(function() {
  var showcase = document.querySelector('.hero-product-showcase');
  if (!showcase) return;

  var slides     = showcase.querySelectorAll('.hero-product-slide');
  var dots       = showcase.querySelectorAll('.hero-dot');
  var captionName = showcase.querySelector('.hero-caption-pill__name');
  var captionPill = showcase.querySelector('.hero-caption-pill');
  var prevBtn    = showcase.querySelector('.hero-nav-btn--prev');
  var nextBtn    = showcase.querySelector('.hero-nav-btn--next');

  if (!slides.length) return;

  var current  = 0;
  var paused   = false;
  var interval;

  function goTo(idx) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = (idx + slides.length) % slides.length;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
    if (captionName) captionName.textContent = slides[current].dataset.name || '';
  }

  function startInterval() {
    clearInterval(interval);
    interval = setInterval(function() {
      if (!paused) goTo(current + 1);
    }, 4200);
  }

  goTo(0);
  startInterval();

  showcase.addEventListener('mouseenter', function() { paused = true; });
  showcase.addEventListener('mouseleave', function() { paused = false; });

  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); startInterval(); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); startInterval(); });

  dots.forEach(function(dot, idx) {
    dot.addEventListener('click', function() { goTo(idx); startInterval(); });
  });

  slides.forEach(function(slide) {
    slide.addEventListener('click', function() {
      var url = slide.dataset.url;
      if (url) window.location.href = url;
    });
  });

  if (captionPill) {
    captionPill.addEventListener('click', function() {
      var url = slides[current].dataset.url;
      if (url) window.location.href = url;
    });
  }

  /* Touch swipe — horizontal swipe navigates slides; vertical gesture
     falls through to native page scroll (same pattern as PDP gallery) */
  var touchStartX = 0;
  var touchStartY = 0;
  showcase.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
    paused = true;
  }, { passive: true });
  showcase.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = e.changedTouches[0].clientY - touchStartY;
    paused = false;
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
    goTo(current + (dx < 0 ? 1 : -1));
    startInterval();
  }, { passive: true });
}());

/* ====================================================
   PDP: Tab Switcher
   ==================================================== */
(function() {
  const tabBtns = document.querySelectorAll('.pdp-tab-btn');
  const tabPanels = document.querySelectorAll('.pdp-tab-panel');
  if (!tabBtns.length) return;

  tabBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const target = btn.dataset.tab;
      tabBtns.forEach(function(b) {
        b.setAttribute('aria-selected', b.dataset.tab === target ? 'true' : 'false');
        b.classList.toggle('is-active', b.dataset.tab === target);
      });
      tabPanels.forEach(function(panel) {
        panel.hidden = panel.dataset.tab !== target;
      });
    });
  });
})();

/* ====================================================
   PDP: Product Image Gallery (Thumbnails + Mobile Dots + Swipe)
   Desktop: thumbnail strip shown, dots hidden (CSS). Thumb clicks navigate.
   Mobile:  thumbnail strip hidden, dots shown (CSS). Dot clicks + left/right
            swipe on the main image navigate. Both update the same goTo(idx).
   ==================================================== */
(function() {
  var thumbs  = document.querySelectorAll('.board-explorer__thumb[data-src]');
  var dots    = document.querySelectorAll('.pdp-image-dots .hero-dot');
  var mainImg = document.querySelector('.board-explorer__main img');
  if (!mainImg) return;

  /* Build full image list from dots (covers all images, not just first 4) */
  var images = [];
  if (dots.length) {
    dots.forEach(function(dot) { images.push(dot.dataset.src || ''); });
  } else {
    thumbs.forEach(function(thumb) { images.push(thumb.dataset.src || ''); });
  }
  if (!images.length) return;

  var current = 0;

  function goTo(idx) {
    idx = ((idx % images.length) + images.length) % images.length;
    if (images[idx]) mainImg.src = images[idx];
    current = idx;
    thumbs.forEach(function(t, i) { t.classList.toggle('is-active', i === idx); });
    dots.forEach(function(d, i) {
      d.classList.toggle('is-active', i === idx);
      d.setAttribute('aria-pressed', i === idx ? 'true' : 'false');
    });
  }

  /* Thumbnail clicks (desktop) */
  thumbs.forEach(function(thumb, i) {
    thumb.addEventListener('click', function() { goTo(i); });
  });

  /* Dot clicks (mobile) */
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); });
  });

  /* Prev/next arrow buttons (desktop + mobile) */
  var prevBtn = document.getElementById('pdp-image-prev');
  var nextBtn = document.getElementById('pdp-image-next');
  if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

  /* Touch swipe on main image (mobile) — horizontal swipe only;
     vertical gestures fall through to native page scroll */
  if (images.length > 1) {
    var container = document.querySelector('.board-explorer__main');
    if (container) {
      var touchStartX = 0;
      var touchStartY = 0;

      container.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      container.addEventListener('touchend', function(e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        /* Require ≥40px horizontal movement; ignore if more vertical than horizontal */
        if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
        goTo(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }
  }
})();

/* ====================================================
   PDP: Variant Selector (genuine multi-variant products only)
   The chip selector on AKD1000/AKD1500 pages no longer
   uses variant switching — those are separate products
   linked via cross-product navigation. This handler
   runs only for products that have real Shopify variants.
   ==================================================== */
(function() {
  var variantBtns = document.querySelectorAll('.pdp-variant-btn');
  if (!variantBtns.length) return;

  function updateVariantUI(variantId) {
    var variants = window.pdpVariants || [];
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) { variant = variants[i]; break; }
    }
    if (!variant) return;

    document.querySelectorAll('.pdp-price').forEach(function(el) {
      el.textContent = variant.price;
    });
    document.querySelectorAll('[data-pdp-sku]').forEach(function(el) {
      el.textContent = (variant.sku || '').toUpperCase();
    });
    document.querySelectorAll('[data-pdp-sku-label]').forEach(function(el) {
      el.textContent = 'SKU ' + (variant.sku || '').toUpperCase();
    });
    var stockBadge = document.getElementById('pdp-stock-badge');
    if (stockBadge) {
      stockBadge.innerHTML = variant.available
        ? '<span class="badge badge--success badge--dot">In stock</span>'
        : '<span class="badge badge--outline">Out of stock</span>';
    }
    var atcBtn     = document.getElementById('pdp-atc-btn');
    var soldOutBtn = document.getElementById('pdp-sold-out-btn');
    if (atcBtn)     atcBtn.style.display    = variant.available ? '' : 'none';
    if (soldOutBtn) {
      soldOutBtn.style.display = variant.available ? 'none' : '';
      soldOutBtn.dataset.variantId = variantId;
    }
  }

  variantBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      variantBtns.forEach(function(b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-checked', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-checked', 'true');
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      var pdpInput   = document.querySelector('#pdp-form input[name="id"]');
      var mobileInput = document.querySelector('#pdp-mobile-form input[name="id"]');
      if (pdpInput)    pdpInput.value    = variantId;
      if (mobileInput) mobileInput.value = variantId;
      updateVariantUI(variantId);
    });
  });
})();

/* ====================================================
   PDP: Add to Cart — AJAX + drawer
   The ATC button is type="submit" inside a native Shopify
   form (action="/cart/add"). Without interception it posts
   and redirects to /cart. This handler prevents that and
   uses the same fetch + openCartDrawer() flow as product
   cards — reading quantity from the PDP stepper input so
   the customer-selected quantity is respected.
   ==================================================== */
(function() {
  var form   = document.getElementById('pdp-form');
  var atcBtn = document.getElementById('pdp-atc-btn');
  if (!form || !atcBtn) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();

    var variantInput = form.querySelector('input[name="id"]');
    var variantId    = variantInput ? variantInput.value : null;
    var qtyInput     = document.getElementById('pdp-qty');
    var qty          = parseInt((qtyInput || {}).value, 10) || 1;
    var maxAttr      = qtyInput ? parseInt(qtyInput.getAttribute('max'), 10) : NaN;
    if (!isNaN(maxAttr) && qty > maxAttr) qty = maxAttr;
    if (!variantId) return;

    var maxQtyInput = form.querySelector('input[name="properties[_max_qty]"]');
    var maxQty = maxQtyInput && maxQtyInput.value ? parseInt(maxQtyInput.value, 10) : null;

    var originalHTML         = atcBtn.innerHTML;
    atcBtn.disabled          = true;
    atcBtn.textContent       = 'Adding…';

    function resetBtn(delay) {
      setTimeout(function() {
        atcBtn.innerHTML         = originalHTML;
        atcBtn.style.background  = '';
        atcBtn.style.color       = '';
        atcBtn.style.borderColor = '';
        atcBtn.disabled          = false;
      }, delay);
    }

    function refreshCounter() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          window._syncHeaderCartCount(cart.item_count);
        });
    }

    function doAdd(qtyToAdd) {
      var addBody = { id: variantId, quantity: qtyToAdd };
      if (maxQty) addBody.properties = { '_max_qty': String(maxQty) };
      return fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify(addBody)
      }).then(function(r) { return r.json(); });
    }

    /* /cart/add.js is additive — repeated clicks would silently stack past
       the per-product cap even though each individual click respects it.
       When this product has a cap, check what's already in the cart for
       this variant first and only add enough to reach (not exceed) it. */
    var addFlow = maxQty
      ? fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          var existingQty = 0;
          cart.items.forEach(function(item) {
            if (String(item.variant_id) === String(variantId)) existingQty += item.quantity;
          });
          var room = Math.max(0, maxQty - existingQty);
          if (room <= 0) {
            return Promise.reject({ limitReached: true, maxQty: maxQty });
          }
          return doAdd(Math.min(qty, room));
        })
      : doAdd(qty);

    addFlow
      .then(function() {
        atcBtn.textContent         = 'Added!';
        atcBtn.style.background    = 'var(--bc-success-bg)';
        atcBtn.style.color         = 'var(--bc-success)';
        atcBtn.style.borderColor   = 'var(--bc-success)';
        window.openCartDrawer();
        refreshCounter();
        resetBtn(1500);
      })
      .catch(function(err) {
        if (err && err.limitReached) {
          atcBtn.textContent         = 'Limit of ' + err.maxQty + ' reached';
          atcBtn.style.background    = 'var(--bc-danger-bg)';
          atcBtn.style.color         = 'var(--bc-danger)';
          atcBtn.style.borderColor   = 'var(--bc-danger)';
          window.openCartDrawer();
          resetBtn(2200);
          return;
        }
        atcBtn.innerHTML = originalHTML;
        atcBtn.disabled  = false;
      });
  });
}());

/* ====================================================
   PDP: Sticky CTA & Qty Sync
   ==================================================== */
(function() {
  const qtyInput = document.getElementById('pdp-qty');
  const mobileForm = document.getElementById('pdp-mobile-form');
  if (!qtyInput || !mobileForm) return;

  document.body.classList.add('has-sticky-cta');
  qtyInput.addEventListener('change', function() {
    let mobileQty = mobileForm.querySelector('input[name="quantity"]');
    if (!mobileQty) {
      mobileQty = document.createElement('input');
      mobileQty.type = 'hidden';
      mobileQty.name = 'quantity';
      mobileForm.appendChild(mobileQty);
    }
    mobileQty.value = qtyInput.value;
  });
})();

/* ====================================================
   Cart: Remove item animation
   ==================================================== */
(function() {
  document.querySelectorAll('.cart-item__remove').forEach(function(btn) {
    btn.addEventListener('click', function() {
      const row = btn.closest('.cart-item');
      if (row) {
        row.style.opacity = '0';
        row.style.transition = 'opacity 200ms';
        setTimeout(function() { row.remove(); }, 200);
      }
    });
  });
})();

/* ====================================================
   Cart: Payment method selection
   ==================================================== */
(function() {
  const paymentOptions = document.querySelectorAll('.payment-option');
  if (!paymentOptions.length) return;

  paymentOptions.forEach(function(btn) {
    btn.addEventListener('click', function() {
      paymentOptions.forEach(function(b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    });
  });
})();

/* ====================================================
   PLP: Filter checkbox — update URL on change
   ==================================================== */
(function() {
  const filterCheckboxes = document.querySelectorAll('.filter-checkbox input[type="checkbox"][data-filter-submit]');
  if (!filterCheckboxes.length) return;

  filterCheckboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      const url = new URL(window.location.href);
      if (checkbox.checked) {
        url.searchParams.set(checkbox.name, checkbox.value);
      } else {
        url.searchParams.delete(checkbox.name);
      }
      window.location.href = url.toString();
    });
  });
})();

/* ====================================================
   PLP: Filter mobile drawer
   ==================================================== */
(function() {
  const filterOpen = document.getElementById('filter-drawer-open');
  const filterClose = document.getElementById('filter-drawer-close');
  const filterCloseFooter = document.getElementById('filter-drawer-close-footer');
  const filterDrawer = document.getElementById('filter-drawer');
  const filterBackdrop = document.getElementById('filter-drawer-backdrop');

  if (!filterDrawer) return;

  function open() {
    filterDrawer.classList.add('is-open');
    filterBackdrop.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    filterDrawer.classList.remove('is-open');
    filterBackdrop.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (filterOpen) filterOpen.addEventListener('click', open);
  if (filterClose) filterClose.addEventListener('click', close);
  if (filterCloseFooter) filterCloseFooter.addEventListener('click', close);
  if (filterBackdrop) filterBackdrop.addEventListener('click', close);
})();

/* ====================================================
   PLP: View toggle (table/grid)
   ==================================================== */
(function() {
  const viewBtns = document.querySelectorAll('.plp-view-btn');
  const tableView = document.querySelector('.plp-table-view');
  const gridView = document.querySelector('.plp-grid-view');

  if (!viewBtns.length) return;

  viewBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const view = btn.dataset.view;
      viewBtns.forEach(function(b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (tableView) tableView.hidden = view !== 'table';
      if (gridView) gridView.hidden = view !== 'grid';
    });
  });
})();

/* ====================================================
   PLP: Sort change
   ==================================================== */
(function() {
  const sortSelect = document.querySelector('.plp-sort');
  if (!sortSelect) return;
  sortSelect.addEventListener('change', function() {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortSelect.value);
    window.location.href = url.toString();
  });
})();

/* ====================================================
   Developer Hub: Resource filter
   ==================================================== */
(function() {
  const filterBtns = document.querySelectorAll('.dev-filter-btn');
  const rows = document.querySelectorAll('.dev-resource-row');
  if (!filterBtns.length) return;

  filterBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      const kind = btn.dataset.kind;

      filterBtns.forEach(function(b) {
        const isActive = b === btn;
        b.style.background = isActive ? 'var(--bc-charcoal)' : '#fff';
        b.style.color = isActive ? '#fff' : 'var(--bc-ink-700)';
        b.style.borderColor = isActive ? 'var(--bc-charcoal)' : 'var(--bc-ink-200)';
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      rows.forEach(function(row) {
        row.style.display = (kind === 'all' || row.dataset.kind === kind) ? 'flex' : 'none';
      });
    });
  });
})();

/* ====================================================
   Product card: Buy now + Add to cart (AJAX)
   Registered in capture phase via setTimeout so our
   handler fires before EarlyBird's bubble listeners.
   ==================================================== */
setTimeout(function() {
  document.addEventListener('click', function(e) {

    // BUY NOW — add to cart then redirect to checkout
    if (e.target.closest('[data-action="buy-now"]')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var btn = e.target.closest('[data-action="buy-now"]');
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = 'Processing...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function(res) { return res.json(); })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() { btn.disabled = false; btn.textContent = 'Buy now'; });
    }

    // ADD TO CART — AJAX, stay on page, show confirmation
    if (e.target.closest('[data-action="add-to-cart"]')) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      var btn = e.target.closest('[data-action="add-to-cart"]');
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      var originalText = btn.textContent.trim();
      var maxQty = btn.dataset.maxQty ? parseInt(btn.dataset.maxQty, 10) : null;

      function doQuickAdd(qtyToAdd) {
        var body = { id: variantId, quantity: qtyToAdd };
        if (maxQty) body.properties = { '_max_qty': String(maxQty) };
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        }).then(function(res) { return res.json(); });
      }

      /* Same additive-cart problem as the PDP: repeated quick-add clicks
         would stack past the cap even though each click only asks for 1. */
      var quickAddFlow = maxQty
        ? fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
            var existingQty = 0;
            cart.items.forEach(function(item) {
              if (String(item.variant_id) === String(variantId)) existingQty += item.quantity;
            });
            if (existingQty >= maxQty) return Promise.reject({ limitReached: true, maxQty: maxQty });
            return doQuickAdd(1);
          })
        : doQuickAdd(1);

      quickAddFlow
      .then(function() {
        btn.textContent = 'Added!';
        window.openCartDrawer();
        btn.style.background = 'var(--bc-success-bg)';
        btn.style.color = 'var(--bc-success)';
        btn.style.borderColor = 'var(--bc-success)';
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            window._syncHeaderCartCount(cart.item_count);
          });
        setTimeout(function() {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.style.color = '';
          btn.style.borderColor = '';
          btn.disabled = false;
        }, 1500);
      })
      .catch(function(err) {
        if (err && err.limitReached) {
          btn.textContent = 'Limit of ' + err.maxQty + ' reached';
          btn.style.background = 'var(--bc-danger-bg)';
          btn.style.color = 'var(--bc-danger)';
          btn.style.borderColor = 'var(--bc-danger)';
          window.openCartDrawer();
          setTimeout(function() {
            btn.textContent = originalText;
            btn.style.background = '';
            btn.style.color = '';
            btn.style.borderColor = '';
            btn.disabled = false;
          }, 2200);
          return;
        }
        btn.textContent = originalText;
        btn.disabled = false;
      });
    }

  }, true); // capture phase — fires before EarlyBird bubble listeners
}, 0);

/* ====================================================
   Cart Drawer
   ==================================================== */
window.openCartDrawer = function() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  if (!drawer || !overlay) return;
  overlay.style.display = 'block';
  setTimeout(function() {
    overlay.style.opacity = '1';
    drawer.style.transform = 'translateX(0)';
  }, 10);
  document.body.classList.add('scroll-lock');
  window.refreshCartDrawer();
};

window.closeCartDrawer = function() {
  var drawer = document.getElementById('cart-drawer');
  var overlay = document.getElementById('cart-drawer-overlay');
  if (!drawer || !overlay) return;
  drawer.style.transform = 'translateX(100%)';
  overlay.style.opacity = '0';
  setTimeout(function() { overlay.style.display = 'none'; }, 300);
  document.body.classList.remove('scroll-lock');
};

/* Header cart badge only exists in the DOM when Liquid first rendered the
   page with item_count > 0 ({% if cart.item_count > 0 %} in header.liquid) —
   every other place in this file that updates it after an AJAX cart change
   was just setting .textContent, which left a literal "0" badge sitting on
   the icon after emptying the cart instead of it disappearing (it should
   look the same as a fresh page load with an empty cart, i.e. no badge at
   all), and silently did nothing if the badge never existed to begin with
   (first add from an empty cart). This creates/removes it as needed so the
   badge's presence always actually matches whether the cart has anything in
   it, regardless of which flow changed it. */
window._syncHeaderCartCount = function(count) {
  var link = document.querySelector('.header-cart-link');
  var badge = document.querySelector('.header-cart-count, [data-cart-count]');
  if (count > 0) {
    if (!badge) {
      if (!link) return;
      badge = document.createElement('span');
      badge.className = 'header-cart-count';
      link.appendChild(badge);
    }
    badge.textContent = count;
  } else if (badge) {
    badge.remove();
  }
};

window.refreshCartDrawer = function() {
  function esc(str) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(String(str || '')));
    return d.innerHTML;
  }
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var itemsEl   = document.getElementById('cart-drawer-items');
      var emptyEl   = document.getElementById('cart-drawer-empty');
      var communityEl = document.getElementById('cart-drawer-community');
      var subtotalEl = document.getElementById('cart-drawer-subtotal');
      window._syncHeaderCartCount(cart.item_count);

      if (cart.item_count === 0) {
        itemsEl.innerHTML = '';
        emptyEl.style.display   = 'block';
        if (communityEl) communityEl.style.display = 'none';
        subtotalEl.textContent  = '$0.00';
        window._updateDrawerVolumeBanner(0);
        return;
      }

      emptyEl.style.display  = 'none';
      if (communityEl) communityEl.style.display = '';
      subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);
      window._updateDrawerVolumeBanner(cart.item_count);

      itemsEl.innerHTML = cart.items.map(function(item) {
        var k   = item.key;
        var img = item.image ? item.image : '';
        var maxQty = item.properties && item.properties._max_qty ? parseInt(item.properties._max_qty, 10) : null;
        return '<div style="display:flex;gap:12px;padding:12px 0;border-bottom:1px solid var(--bc-ink-100);position:relative;">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(item.title) + '" style="width:72px;height:72px;object-fit:contain;border:1px solid var(--bc-ink-200);border-radius:6px;flex-shrink:0;">'
               : '<div style="width:72px;height:72px;background:var(--bc-ink-050);border-radius:6px;flex-shrink:0;"></div>') +
          '<div style="flex:1;min-width:0;padding-right:24px;">' +
            '<p style="font-size:13px;font-weight:600;margin:0 0 4px;line-height:1.3;">' + esc(item.product_title) + '</p>' +
            '<p style="font-size:11px;color:var(--bc-ink-500);margin:0 0 8px;font-family:var(--font-mono);">' + esc(item.sku) + '</p>' +
            '<div style="display:flex;align-items:center;justify-content:space-between;">' +
              '<div style="display:flex;align-items:center;gap:4px;border:1px solid var(--bc-ink-300);border-radius:4px;overflow:hidden;">' +
                '<button class="cart-dq-btn" data-item-key="' + esc(k) + '" data-delta="-1" ' +
                  'style="width:28px;height:28px;border:none;background:#fff;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;color:var(--bc-charcoal);">&#8722;</button>' +
                '<input class="cart-dq-input" type="number" data-item-key="' + esc(k) + '" ' +
                  'value="' + item.quantity + '" min="1"' + (maxQty ? ' max="' + maxQty + '"' : '') + ' ' +
                  'style="width:36px;border:none;outline:none;text-align:center;font-family:var(--font-mono);font-size:13px;font-weight:600;background:transparent;-moz-appearance:textfield;appearance:textfield;">' +
                '<button class="cart-dq-btn" data-item-key="' + esc(k) + '" data-delta="1" ' +
                  'style="width:28px;height:28px;border:none;background:#fff;cursor:pointer;font-size:16px;display:flex;align-items:center;justify-content:center;color:var(--bc-charcoal);">+</button>' +
              '</div>' +
              '<span class="cart-dq-line-price" data-item-key="' + esc(k) + '" data-unit-price="' + item.final_price + '" ' +
                'style="font-family:var(--font-mono);font-size:13px;font-weight:600;">' +
                '$' + (item.final_line_price / 100).toFixed(2) +
              '</span>' +
            '</div>' +
          '</div>' +
          '<button onclick="window.updateCartItem(\'' + esc(k).replace(/'/g, "\\'") + '\', 0)" ' +
            'aria-label="Remove item" ' +
            'style="position:absolute;top:14px;right:0;background:none;border:none;cursor:pointer;padding:2px;color:var(--bc-ink-400);transition:color 0.15s;" ' +
            'onmouseover="this.style.color=\'#dc2626\'" ' +
            'onmouseout="this.style.color=\'var(--bc-ink-400)\'">' +
            '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
              '<polyline points="3 6 5 6 21 6"/>' +
              '<path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>' +
              '<path d="M10 11v6M14 11v6"/>' +
              '<path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>' +
            '</svg>' +
          '</button>' +
        '</div>';
      }).join('');
    })
    .catch(function() {
      var itemsEl = document.getElementById('cart-drawer-items');
      if (itemsEl) itemsEl.innerHTML = '<p style="font-family:var(--font-body);font-size:13px;padding:16px 0;">Could not load cart. Please refresh.</p>';
    });
};

/* updateCartItem: sequenced requests per item key — only the latest response
   is ever applied, preventing stale overwrites from slow earlier requests. */
var _cartReqSeq = {};
window.updateCartItem = function(key, quantity) {
  if (!_cartReqSeq[key]) _cartReqSeq[key] = 0;
  var seq = ++_cartReqSeq[key];

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    // Discard if a newer request for this key has already been sent
    if (seq !== _cartReqSeq[key]) return;

    window._syncHeaderCartCount(cart.item_count);

    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    if (subtotalEl) subtotalEl.textContent = '$' + (cart.total_price / 100).toFixed(2);

    // Update volume banner in drawer
    window._updateDrawerVolumeBanner(cart.item_count);

    var item = cart.items.find(function(i) { return i.key === key; });
    if (item) {
      var inp    = document.querySelector('.cart-dq-input[data-item-key="' + key + '"]');
      var lineEl = document.querySelector('.cart-dq-line-price[data-item-key="' + key + '"]');
      if (inp) inp.value = item.quantity;
      if (lineEl) {
        lineEl.textContent = '$' + (item.final_line_price / 100).toFixed(2);
        lineEl.setAttribute('data-unit-price', item.final_price);
      }
    } else {
      window.refreshCartDrawer();
    }
  })
  .catch(function() { window.refreshCartDrawer(); });
};

/* Delegated handlers for cart drawer +/- buttons and direct-edit input */
;(function() {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  // +/- button clicks: optimistic update then server reconcile
  drawer.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-dq-btn');
    if (!btn) return;
    e.preventDefault();
    var key   = btn.getAttribute('data-item-key');
    var delta = parseInt(btn.getAttribute('data-delta'), 10);
    var inp   = drawer.querySelector('.cart-dq-input[data-item-key="' + key + '"]');
    var lineEl = drawer.querySelector('.cart-dq-line-price[data-item-key="' + key + '"]');
    if (!inp) return;

    var maxQty = inp.getAttribute('max') ? parseInt(inp.getAttribute('max'), 10) : null;
    var currentQty = Math.max(0, parseInt(inp.value, 10) || 0);
    var newQty = Math.max(0, currentQty + delta);
    if (maxQty && newQty > maxQty) newQty = maxQty;

    // Optimistic: update qty display immediately
    inp.value = newQty;

    // Optimistic: update line price using stored unit price
    if (lineEl) {
      var unitPrice = parseInt(lineEl.getAttribute('data-unit-price'), 10) || 0;
      lineEl.textContent = '$' + ((unitPrice * newQty) / 100).toFixed(2);
    }

    // Optimistic: recompute subtotal from all visible line prices
    var runningTotal = 0;
    drawer.querySelectorAll('.cart-dq-line-price').forEach(function(el) {
      runningTotal += parseFloat(el.textContent.replace(/[^0-9.]/g, '')) || 0;
    });
    var subtotalEl = document.getElementById('cart-drawer-subtotal');
    if (subtotalEl) subtotalEl.textContent = '$' + runningTotal.toFixed(2);

    window.updateCartItem(key, newQty);
  });

  // Direct input: update on blur or Enter
  drawer.addEventListener('change', function(e) {
    var inp = e.target.closest('.cart-dq-input');
    if (!inp) return;
    var key    = inp.getAttribute('data-item-key');
    var maxQty = inp.getAttribute('max') ? parseInt(inp.getAttribute('max'), 10) : null;
    var newQty = Math.max(1, parseInt(inp.value, 10) || 1);
    if (maxQty && newQty > maxQty) newQty = maxQty;
    inp.value  = newQty;
    window.updateCartItem(key, newQty);
  });

  drawer.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    var inp = e.target.closest('.cart-dq-input');
    if (inp) inp.blur(); // triggers change event
  });
})();

/* ── Cart drawer volume banner ── */
window._updateDrawerVolumeBanner = function(itemCount) {
  var banner = document.getElementById('cart-drawer-volume-banner');
  if (!banner) return;
  banner.style.display = itemCount >= 10 ? 'flex' : 'none';
};

/* ── Full cart page volume banner ── */
window._updatePageVolumeBanner = function(itemCount) {
  var banner = document.getElementById('cart-page-volume-banner');
  if (!banner) return;
  banner.style.display = itemCount >= 10 ? 'flex' : 'none';
};

/* ── Minmaxify quantity shake feedback ──────────────────────────────────
   Minmaxify injects an error element when a limit is hit. We watch for
   it with a MutationObserver and layer a shake + red flash on the qty
   input when it appears — without touching Minmaxify's own message. */
(function() {
  var style = document.createElement('style');
  style.textContent =
    '@keyframes bc-qty-shake {' +
      '0%,100%{transform:translateX(0)}' +
      '20%{transform:translateX(-5px)}' +
      '40%{transform:translateX(5px)}' +
      '60%{transform:translateX(-4px)}' +
      '80%{transform:translateX(4px)}' +
    '}' +
    '.bc-qty-shake {' +
      'animation: bc-qty-shake 350ms ease;' +
      'border-color: var(--bc-danger) !important;' +
      'background: var(--bc-danger-bg) !important;' +
    '}';
  document.head.appendChild(style);

  function shakeNearby(errorEl) {
    // Walk up to find the qty control wrapper (sibling/ancestor of the error)
    var container = errorEl.closest('[data-minmaxify-message]') ||
                    errorEl.closest('form') ||
                    errorEl.parentElement;
    if (!container) return;
    var inp = container.querySelector('input[type="number"], .cart-dq-input, [data-cart-qty]') ||
              document.querySelector('.cart-dq-input, input[name="quantity"]');
    if (!inp) return;
    inp.classList.remove('bc-qty-shake');
    // force reflow so re-adding the class re-triggers the animation
    void inp.offsetWidth;
    inp.classList.add('bc-qty-shake');
    setTimeout(function() { inp.classList.remove('bc-qty-shake'); }, 400);
  }

  // Watch the entire document for Minmaxify error node insertion
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        // Minmaxify uses data-minmaxify-message or class names containing 'minmaxify'/'order-limit'
        var isMMX = node.hasAttribute('data-minmaxify-message') ||
                    (node.className && /minmaxify|order.limit/i.test(node.className));
        if (isMMX) { shakeNearby(node); return; }
        // Also check children (Minmaxify may wrap the message)
        var inner = node.querySelector('[data-minmaxify-message], [class*="minmaxify"], [class*="order-limit"]');
        if (inner) shakeNearby(inner);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

window.updateCartCTA = function() {
  var checkbox = document.getElementById('cart-terms-checkbox');
  var btn      = document.getElementById('cart-checkout-btn');
  var errEl    = document.getElementById('cart-terms-error');
  if (!checkbox || !btn) return;
  if (checkbox.checked) {
    btn.style.opacity       = '1';
    btn.style.pointerEvents = 'auto';
    btn.style.cursor        = 'pointer';
    btn.style.background    = 'var(--bc-blue)';
    if (errEl) errEl.style.display = 'none';
  } else {
    btn.style.opacity       = '0.5';
    btn.style.pointerEvents = 'none';
    btn.style.cursor        = 'not-allowed';
  }
};

/* Hard backstop: fires if pointer-events is bypassed via dev tools */
window.checkCartTerms = function() {
  var checkbox = document.getElementById('cart-terms-checkbox');
  var errEl    = document.getElementById('cart-terms-error');
  if (checkbox && !checkbox.checked) {
    if (errEl) errEl.style.display = 'block';
    return false; /* prevents href navigation */
  }
  return true;
};

/* Cart drawer consent gating */
window.updateDrawerCTA = function() {
  var checkbox = document.getElementById('cart-drawer-terms');
  var btn      = document.getElementById('cart-drawer-checkout-btn');
  var errEl    = document.getElementById('cart-drawer-terms-error');
  if (!checkbox || !btn) return;
  if (checkbox.checked) {
    btn.style.opacity       = '1';
    btn.style.pointerEvents = 'auto';
    btn.style.cursor        = 'pointer';
    if (errEl) errEl.style.display = 'none';
  } else {
    btn.style.opacity       = '0.5';
    btn.style.pointerEvents = 'none';
    btn.style.cursor        = 'not-allowed';
  }
};

window.checkDrawerTerms = function() {
  var checkbox = document.getElementById('cart-drawer-terms');
  var errEl    = document.getElementById('cart-drawer-terms-error');
  if (checkbox && !checkbox.checked) {
    if (errEl) errEl.style.display = 'block';
    return false;
  }
  return true;
};

/* Full cart page: +/- button clicks with optimistic update */
document.addEventListener('click', function(e) {
  var el = e.target.closest('[data-action="cart-qty"]');
  if (!el) return;
  e.preventDefault();
  var key = el.getAttribute('data-item-key');
  var qty = parseInt(el.getAttribute('data-qty'), 10);
  if (isNaN(qty) || qty < 0) qty = 0;
  var maxQty = el.getAttribute('data-max') ? parseInt(el.getAttribute('data-max'), 10) : null;
  if (maxQty && qty > maxQty) qty = maxQty;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Sequence guard: discard stale responses if clicks arrive faster than responses
  if (!_cartReqSeq[key]) _cartReqSeq[key] = 0;
  var seq = ++_cartReqSeq[key];

  // Optimistic: update displayed qty immediately
  var qtyEl = document.querySelector('[data-cart-qty="' + key + '"]');
  if (qtyEl) {
    if (qtyEl.tagName === 'INPUT') qtyEl.value = qty;
    else qtyEl.textContent = qty;
  }
  // Optimistic: update each button's data-qty using data-delta
  document.querySelectorAll('[data-action="cart-qty"][data-item-key="' + key + '"]').forEach(function(btn) {
    var d = parseInt(btn.getAttribute('data-delta') || '0', 10);
    btn.setAttribute('data-qty', qty + d);
  });

  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    if (seq !== _cartReqSeq[key]) return;

    var item      = cart.items.find(function(i) { return i.key === key; });
    var lineEl    = document.querySelector('[data-cart-line-price="' + key + '"]');
    var unitEl    = document.querySelector('[data-cart-unit-price="' + key + '"]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var totalEl   = document.querySelector('[data-cart-total]');

    window._updatePageVolumeBanner(cart.item_count);

    if (item) {
      // Reconcile with server truth
      if (qtyEl) {
        if (qtyEl.tagName === 'INPUT') qtyEl.value = item.quantity;
        else qtyEl.textContent = item.quantity;
      }
      document.querySelectorAll('[data-action="cart-qty"][data-item-key="' + key + '"]').forEach(function(btn) {
        var d = parseInt(btn.getAttribute('data-delta') || '0', 10);
        btn.setAttribute('data-qty', item.quantity + d);
      });
      if (lineEl) lineEl.textContent = formatMoney(item.final_line_price);
      if (unitEl) unitEl.textContent = formatMoney(item.final_price) + ' ea';
    } else {
      // Item removed: remove its row from DOM
      var row = qtyEl && qtyEl.closest('[style*="grid-template-columns"]');
      if (row) row.remove();
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl)    totalEl.textContent    = formatMoney(cart.total_price);
  });
});

/* Full cart page: direct input editing */
document.addEventListener('change', function(e) {
  var inp = e.target.closest('[data-cart-qty]');
  if (!inp || inp.tagName !== 'INPUT') return;
  var key    = inp.getAttribute('data-cart-qty');
  var maxQty = inp.getAttribute('max') ? parseInt(inp.getAttribute('max'), 10) : null;
  var newQty = Math.max(1, parseInt(inp.value, 10) || 1);
  if (maxQty && newQty > maxQty) newQty = maxQty;
  inp.value  = newQty;
  // Update button data-qty values
  document.querySelectorAll('[data-action="cart-qty"][data-item-key="' + key + '"]').forEach(function(btn) {
    var d = parseInt(btn.getAttribute('data-delta') || '0', 10);
    btn.setAttribute('data-qty', newQty + d);
  });
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  })
  .then(function(r) { return r.json(); })
  .then(function(cart) {
    var item      = cart.items.find(function(i) { return i.key === key; });
    var lineEl    = document.querySelector('[data-cart-line-price="' + key + '"]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var totalEl   = document.querySelector('[data-cart-total]');
    window._updatePageVolumeBanner(cart.item_count);
    if (item) {
      inp.value = item.quantity;
      if (lineEl) lineEl.textContent = formatMoney(item.final_line_price);
    }
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl)    totalEl.textContent    = formatMoney(cart.total_price);
  });
});

// ============================================
// NEWSLETTER POPUP
// ============================================
(function() {
  var STORAGE_KEY = 'bc_newsletter';
  var SESSION_KEY = 'bc_newsletter_shown';

  function subscriberStatus() { return localStorage.getItem(STORAGE_KEY); }

  function showAlreadySubscribed() {
    var formWrap = document.getElementById('newsletter-form-wrap');
    var success  = document.getElementById('newsletter-success');
    if (formWrap) formWrap.style.display = 'none';
    if (success)  success.style.display  = 'block';
  }

  var path       = window.location.pathname;
  var onCheckout = path.indexOf('/checkouts') !== -1 || path.indexOf('/checkout') !== -1;

  // Auto-open: once per session after 6 seconds — only for visitors who haven't decided yet
  if (!onCheckout && subscriberStatus() !== 'subscribed' && subscriberStatus() !== 'dismissed' && !sessionStorage.getItem(SESSION_KEY)) {
    setTimeout(function() {
      var overlay = document.getElementById('newsletter-overlay');
      var popup   = document.getElementById('newsletter-popup');
      if (!overlay || !popup) return;
      sessionStorage.setItem(SESSION_KEY, '1');
      overlay.style.display = 'flex';
      popup.style.display   = 'block';
      document.body.classList.add('scroll-lock');
    }, 6000);
  }

  // Manual open (called from floating button) — always available, regardless of prior status
  window.openNewsletter = function() {
    var overlay = document.getElementById('newsletter-overlay');
    var popup   = document.getElementById('newsletter-popup');
    if (!overlay || !popup) return;
    sessionStorage.setItem(SESSION_KEY, '1');
    if (subscriberStatus() === 'subscribed') showAlreadySubscribed();
    overlay.style.display = 'flex';
    popup.style.display   = 'block';
    document.body.classList.add('scroll-lock');
  };

  var overlay = document.getElementById('newsletter-overlay');
  if (overlay) {
    overlay.addEventListener('click', function() { if (window.closeNewsletter) window.closeNewsletter(); });
  }

  // Reflect prior subscription in the footer form on every page load
  var footerEmail = document.getElementById('footer-newsletter-email');
  if (footerEmail && subscriberStatus() === 'subscribed') {
    footerEmail.placeholder = 'You are subscribed!';
    footerEmail.disabled = true;
  }
})();

window.closeNewsletter = function() {
  var overlay = document.getElementById('newsletter-overlay');
  var popup = document.getElementById('newsletter-popup');
  if (overlay) overlay.style.display = 'none';
  if (popup) popup.style.display = 'none';
  document.body.classList.remove('scroll-lock');
  if (localStorage.getItem('bc_newsletter') !== 'subscribed') {
    localStorage.setItem('bc_newsletter', 'dismissed');
  }
};

/* ====================================================
   Mailchimp direct signup
   Posts straight to the Mailchimp audience via a hidden
   iframe target (the same mechanism Mailchimp's own
   "embedded form" uses) so newsletter signups land only
   in Mailchimp — no Shopify customer record is created.
   Cross-origin, so we can't read a real success/failure
   response back; we optimistically confirm after a beat.
   ==================================================== */
var MC_ACTION_URL   = 'https://brainchip.us18.list-manage.com/subscribe/post?u=7b5c197057900cda2e19e9c6a&id=67d3155124&f_id=000db3e6f0';
var MC_HONEYPOT_NAME = 'b_7b5c197057900cda2e19e9c6a_67d3155124';
var MC_SIGNUP_TAG    = '3132461'; // "Official Newsletter Signups" tag ID, from Mailchimp's own embed form code

function submitToMailchimp(email) {
  var form = document.createElement('form');
  form.action = MC_ACTION_URL;
  form.method = 'POST';
  form.target = 'mc-signup-frame';
  form.style.display = 'none';

  function addField(name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  addField('EMAIL', email);
  addField('tags', MC_SIGNUP_TAG);
  addField(MC_HONEYPOT_NAME, ''); // honeypot — must stay empty

  document.body.appendChild(form);
  form.submit();
  form.parentNode.removeChild(form);
}

function markNewsletterSubscribed() {
  localStorage.setItem('bc_newsletter', 'subscribed');
  var footerEmail = document.getElementById('footer-newsletter-email');
  if (footerEmail) {
    footerEmail.value = '';
    footerEmail.placeholder = 'You are subscribed!';
    footerEmail.disabled = true;
  }
}

window.submitNewsletter = function() {
  if (localStorage.getItem('bc_newsletter') === 'subscribed') {
    document.getElementById('newsletter-form-wrap').style.display = 'none';
    document.getElementById('newsletter-success').style.display = 'block';
    return;
  }

  var email = document.getElementById('newsletter-email').value.trim();
  var gdpr = document.getElementById('newsletter-gdpr').checked;
  var btn = document.getElementById('newsletter-submit');

  if (!email || !email.includes('@')) {
    document.getElementById('newsletter-email').style.borderColor = 'var(--bc-danger)';
    return;
  }

  if (!gdpr) {
    alert('Please agree to receive marketing emails to continue.');
    return;
  }

  btn.textContent = 'Joining...';
  btn.disabled = true;

  submitToMailchimp(email);

  setTimeout(function() {
    document.getElementById('newsletter-form-wrap').style.display = 'none';
    document.getElementById('newsletter-success').style.display = 'block';
    markNewsletterSubscribed();
    setTimeout(window.closeNewsletter, 3000);
  }, 600);
};

/* ====================================================
   Footer Newsletter
   ==================================================== */
window.submitFooterNewsletter = function() {
  var email = document.getElementById('footer-newsletter-email');
  if (localStorage.getItem('bc_newsletter') === 'subscribed') {
    if (email) { email.value = ''; email.placeholder = 'You are subscribed!'; email.disabled = true; }
    return;
  }
  if (!email || !email.value.trim() || !email.value.includes('@')) {
    email.style.borderColor = 'var(--bc-danger)';
    return;
  }
  var trimmedEmail = email.value.trim();
  submitToMailchimp(trimmedEmail);

  setTimeout(function() {
    markNewsletterSubscribed();
  }, 600);
};

/* ====================================================
   Back-in-stock notification popup
   Submits to Shopify's /contact endpoint with a
   bis-specific tag so it stays separate from the
   general newsletter list. EarlyBird can pick up
   submissions via its Shopify integration, or we
   route these to a tagged segment independently.
   ==================================================== */
var _bisVariantId = '';
var _bisProductName = '';

window.openBisPopup = function(productName, variantId) {
  _bisVariantId    = variantId || '';
  _bisProductName  = productName || '';

  var overlay  = document.getElementById('bis-overlay');
  var popup    = document.getElementById('bis-popup');
  var nameEl   = document.getElementById('bis-product-name');
  var emailEl  = document.getElementById('bis-email');
  var submitEl = document.getElementById('bis-submit');
  var errorEl  = document.getElementById('bis-error');
  var formWrap = document.getElementById('bis-form-wrap');
  var success  = document.getElementById('bis-success');

  if (!overlay || !popup) return;

  // Reset state
  if (nameEl)   nameEl.textContent  = productName || '';
  if (emailEl)  { emailEl.value = ''; emailEl.style.borderColor = ''; }
  if (submitEl) { submitEl.textContent = 'Notify me'; submitEl.disabled = false; }
  if (errorEl)  { errorEl.style.display = 'none'; errorEl.textContent = ''; }
  if (formWrap) formWrap.style.display = '';
  if (success)  success.style.display  = 'none';

  overlay.style.display = 'flex';
  popup.style.display   = 'block';
  document.body.classList.add('scroll-lock');
  if (emailEl) setTimeout(function() { emailEl.focus(); }, 50);
};

window.closeBisPopup = function() {
  var overlay = document.getElementById('bis-overlay');
  var popup   = document.getElementById('bis-popup');
  if (overlay) overlay.style.display = 'none';
  if (popup)   popup.style.display   = 'none';
  document.body.classList.remove('scroll-lock');
};

window.submitBisForm = function() {
  var emailEl  = document.getElementById('bis-email');
  var submitEl = document.getElementById('bis-submit');
  var errorEl  = document.getElementById('bis-error');
  var formWrap = document.getElementById('bis-form-wrap');
  var success  = document.getElementById('bis-success');
  var email    = emailEl ? emailEl.value.trim() : '';

  if (errorEl) { errorEl.style.display = 'none'; errorEl.textContent = ''; }
  if (emailEl) emailEl.style.borderColor = '';

  if (!email || !email.includes('@') || !email.includes('.')) {
    if (errorEl) { errorEl.textContent = 'Please enter a valid email address.'; errorEl.style.display = 'block'; }
    if (emailEl) { emailEl.style.borderColor = 'var(--bc-danger)'; emailEl.focus(); }
    return;
  }

  if (submitEl) { submitEl.textContent = 'Signing up…'; submitEl.disabled = true; }

  // Submit to Shopify /contact with bis-specific tags — keeps this list
  // separate from the general newsletter (different contact[tags] value).
  var formData = new FormData();
  formData.append('contact[email]', email);
  formData.append('contact[tags]',  'back-in-stock-request,bis-' + (_bisVariantId || 'unknown'));
  formData.append('contact[body]',  'Back-in-stock request for: ' + (_bisProductName || '') + ' (variant ' + (_bisVariantId || '') + ')');
  formData.append('form_type', 'contact');
  formData.append('utf8', '✓');

  fetch('/contact', {
    method:  'POST',
    body:    formData,
    headers: { 'Accept': 'application/json' }
  })
  .then(function() {
    if (formWrap) formWrap.style.display = 'none';
    if (success)  success.style.display  = 'block';
    setTimeout(window.closeBisPopup, 3000);
  })
  .catch(function() {
    if (errorEl)  { errorEl.textContent = 'Something went wrong — please try again.'; errorEl.style.display = 'block'; }
    if (submitEl) { submitEl.textContent = 'Notify me'; submitEl.disabled = false; }
  });
};

/* ====================================================
   Newsletter FAB: fade out before footer overlaps
   Uses IntersectionObserver on the site footer with a
   rootMargin that fires ~100px before the footer enters
   the viewport, preventing the button from sitting on
   top of footer content. Fades back in when the footer
   scrolls out of view. Works on top of any existing
   session-based suppression (dismissed/subscribed users
   never see the FAB regardless of this scroll state).
   ==================================================== */
(function() {
  var fab    = document.getElementById('pdp-newsletter-fab');
  var footer = document.querySelector('.site-footer');
  if (!fab || !footer) return;

  fab.style.transition = 'opacity 200ms ease';

  function setFabVisible(visible) {
    fab.style.opacity       = visible ? '' : '0';
    fab.style.pointerEvents = visible ? '' : 'none';
  }

  var observer = new IntersectionObserver(function(entries) {
    setFabVisible(!entries[0].isIntersecting);
  }, {
    /* Positive bottom rootMargin expands the detection zone downward,
       so the observer fires when the footer is 100px below the viewport
       bottom — i.e. just before it scrolls into view. */
    rootMargin: '0px 0px 100px 0px'
  });

  observer.observe(footer);
}());
